const initialState = {
    publicacoes: [],
    usuarios: []
}

const publicacoesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_PUBLICACOES':
            return {
                ...state,
                publicacoes: action.payload
            }
        case 'SET_USUARIOS':
            return {
                ...state,
                usuarios: action.payload
            }
        default:
            return state;
    }
}

export default publicacoesReducer;